import { Box, Image, Stack, Text } from '@chakra-ui/react';
import { getImageUrl } from '@habity/services';
import { ImageType } from '@habity/types';
import { ListSkeleton } from '~/components/homes/list/components/ListSkeleton';
import { useState } from 'react';
import { CarouselIconButton } from '~/components/ui/images/buttons/CarouselIconButton';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';

interface FloorPlanProps {
  images: ImageType[];
  handleOpenGallery: (...args: any) => void;
}

export function FloorPlan({ images, handleOpenGallery }: FloorPlanProps) {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const onPrev = () => {
    if (currentIndex === 0) return;
    setCurrentIndex((prev) => prev - 1);
  };

  const onNext = () => {
    if (currentIndex >= images.length - 1) return;
    setCurrentIndex((prev) => prev + 1);
  };

  if (!images.length) return null;

  // Current image is shown
  // The rest are hidden but still in the DOM for the gallery view

  return (
    <Stack>
      <Text fontWeight="light" size={{ mobile: 'sm', desktop: 'md' }}>
        Planritning
      </Text>

      <Text fontSize="xs" color="gray.600">
        Ritningen är inte skalenlig och avvikelser kan förekomma.
      </Text>

      {images.length > 1 && (
        <Text fontWeight="medium">
          {currentIndex + 1} av {images.length}
        </Text>
      )}

      {/* Modal version */}
      <Box position="relative">
        {images.map((image, idx) => (
          <Image
            key={image.id}
            display={idx === currentIndex ? 'block' : 'none'}
            cursor="pointer"
            objectFit="contain"
            src={getImageUrl(image, 'full')}
            fallback={<ListSkeleton isLoaded={false} />}
            onClick={handleOpenGallery}
          />
        ))}

        {/* Navigation buttons positioned on left/right of image */}
        {images.length > 1 && (
          <>
            {currentIndex > 0 && (
              <CarouselIconButton
                onClick={onPrev}
                size="sm"
                left="3"
                display="inline-flex"
                icon={<IoChevronBackOutline />}
                aria-label="Föregående planritning"
              />
            )}
            {currentIndex < images.length - 1 && (
              <CarouselIconButton
                onClick={onNext}
                size="sm"
                right="3"
                display="inline-flex"
                icon={<IoChevronForwardOutline />}
                aria-label="Nästa planritning"
              />
            )}
          </>
        )}
      </Box>
    </Stack>
  );
}
